export default {
  RepxLogs: 'Repx Logs',
  VehicleDamage: 'Vehicle Damage'
}
